import { currentSuggestion, isLoading, error } from '../state'
import { useSuggestionsManagement } from '../../use-suggestions-management'

/**
 * Belirtilen ID'ye sahip öneriyi yükler
 * @param {String|Number} suggestionId - Yüklenecek önerinin ID'si
 * @returns {Promise<Object|null>} Yüklenen öneri verisi veya hata durumunda null
 */
export const loadSuggestion = async (suggestionId) => {
  if (!suggestionId) {
    error.value = 'Geçerli bir öneri ID\'si sağlanmadı'
    return null
  }

  try {
    isLoading.value = true
    error.value = null

    // Suggestion management composable'dan getSuggestion metodunu al
    const { getSuggestion } = useSuggestionsManagement()

    // Öneriyi getir
    const suggestion = await getSuggestion(suggestionId)

    if (!suggestion) {
      error.value = `ID: ${suggestionId} olan öneri bulunamadı`
      currentSuggestion.value = null
      return null
    }

    // State'i güncelle
    currentSuggestion.value = suggestion
    return suggestion
  } catch (err) {
    console.error('Öneri yüklenirken hata oluştu:', err)
    error.value = err.message || 'Öneri yüklenirken bir hata oluştu'
    currentSuggestion.value = null
    return null
  } finally {
    isLoading.value = false
  }
}
